// IMPORT REACT
import React from 'react';

import YAButton from '../../Form/Button';
import YACollapse from '../Collapse';

// IMPORT STYLES
import { SC_Card, SC_CardHeader, SC_CardBody } from '../styles';


class YACard extends React.Component {

  state = {
    collapseOpen: false
  };
  
  render(){
    const header = this.props.header;
    const body = this.props.body;
    const id = this.props.id;
    const collapseOpen = this.state.collapseOpen;

    return (
      <SC_Card>
        <SC_CardHeader>
          <YAButton
            onClick={(e) => {
              e.preventDefault();
              this.setState({
                collapseOpen: !collapseOpen
              })
            }}
            collapseOpen={collapseOpen}
            aria-expanded={collapseOpen}
            block="true" 
            color="link" 
            icon="caret" 
            iconColor="teal"
          >
            {header}
          </YAButton>
        </SC_CardHeader>
        <YACollapse collapseOpen={collapseOpen}>
          <SC_CardBody>
            {body}
          </SC_CardBody>
        </YACollapse>
      </SC_Card>
    );
  } 
};
export default YACard;